import { fetchLeadTasks, fetchTeamBoardCardLocation } from "../../api/client";
import { pickActivityTask } from "./activityLogDisplay";

function taskList(data) {
  if (Array.isArray(data?.tasks)) return data.tasks;
  if (Array.isArray(data?.data?.tasks)) return data.data.tasks;
  return [];
}

function isGenericTaskTitle(title) {
  const needle = String(title || "")
    .toLowerCase()
    .replace(/#\d+/g, "")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
  return !needle || /^(concluiu |criou |reiniciou |apagou |reabriu )?(uma )?tarefa( vinculada)?$/.test(needle);
}

function pickGenericTask(cards) {
  const list = Array.isArray(cards) ? cards : [];
  if (list.length === 1) return list[0];
  const done = list.filter((card) => card?.completedAt || card?.columnIsDone);
  if (done.length === 1) return done[0];
  if (done.length > 1) {
    return [...done].sort((a, b) => String(b.completedAt || "").localeCompare(String(a.completedAt || "")))[0];
  }
  return null;
}

async function locateCard(cardId) {
  const location = await fetchTeamBoardCardLocation(cardId);
  const boardId = Number(location?.boardId ?? location?.board_id);
  const id = Number(location?.cardId || cardId);
  if (!Number.isFinite(boardId) || boardId <= 0 || !Number.isFinite(id) || id <= 0) return null;
  return {
    id,
    boardId,
    title: location?.title || "",
  };
}

export async function resolveActivityTask({ cardId, title, leadId }) {
  const resolvedId = cardId ? Number(cardId) : null;
  if (resolvedId > 0) {
    try {
      const located = await locateCard(resolvedId);
      if (located) return located;
    } catch {
      /* o id do texto pode não ser o card; segue pela lista da solicitação */
    }
  }

  let cards = [];
  if (leadId) {
    try {
      const data = await fetchLeadTasks(leadId);
      cards = taskList(data);
    } catch {
      cards = [];
    }
  }

  const picked = pickActivityTask(cards, { cardId: resolvedId, title });
  const generic = !picked && isGenericTaskTitle(title) ? pickGenericTask(cards) : null;
  const chosen = picked?.id ? picked : generic;
  if (!chosen?.id) return null;
  if (chosen.boardId) return chosen;
  try {
    return (await locateCard(chosen.id)) || chosen;
  } catch {
    return chosen.boardId ? chosen : null;
  }
}
